import * as actions from "./actionTypes";
import { setLoading, setMessage } from "./general";
import axios from "../../config/axiosInstance";
import timeclockInstance from "../../config/timeclockInstance";
import authInstance from "../../config/authInstance";

export const authSuccess = (
  token,
  companyCode,
  socialName,
  userName,
  isEmployee,
  cnpj,
  hasEmployee,
  businessName,
  privileges
) => ({
  type: actions.AUTH_SUCCESS,
  token,
  companyCode,
  socialName,
  userName,
  isEmployee,
  cnpj,
  hasEmployee,
  businessName,
  privileges,
});

export const auth = (data, isLogin) => (dispatch) => {
  dispatch(setLoading(true));
  localStorage.setItem("email", data.email);
  const url = isLogin ? "authentication/signin/dashboard" : "/account";
  const instance = isLogin ? authInstance : axios;
  return instance
    .post(url, data)
    .then((response) => {
      const {
        companyCode,
        socialName,
        cnpj,
        businessName,
      } = response.data.company;
      const { name } = response.data.user;
      const { isAdmin, privileges, companies, hasEmployee } = response.data;
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("companyCode", companyCode);
      localStorage.setItem("socialName", socialName);
      localStorage.setItem("userName", name);
      localStorage.setItem("isAdmin", isAdmin);
      localStorage.setItem("isEmployee", false);
      localStorage.setItem("cnpj", cnpj);
      localStorage.setItem("hasEmployee", hasEmployee);
      localStorage.setItem("businessName", businessName);
      localStorage.setItem("privileges", JSON.stringify(privileges));
      localStorage.setItem("companies", JSON.stringify(companies || []));
      localStorage.setItem('warningPre', false);

      dispatch(
        authSuccess(
          response.data.token,
          companyCode,
          socialName,
          name,
          null,
          cnpj,
          hasEmployee,
          businessName,
          privileges
        )
      );
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const employeeAuth = (token, companyCode, socialName, businessName) => ({
  type: "EMPLOYEE_AUTH",
  token,
  companyCode,
  socialName,
  userName: socialName,
  isEmployee: true,
  businessName,
});

const verifyCredentials = (credentials, dispatch) =>
  authInstance
    .post("/authentication/signin/app", credentials)
    .then((res) => {
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("companyCode", credentials.companyCode);
      localStorage.setItem("userName", credentials.name);
      localStorage.setItem("socialName", credentials.name);
      localStorage.setItem("isEmployee", true);
      localStorage.setItem("businessName", credentials.businessName);
      localStorage.setItem("email", credentials.email);

      const info = {
        name: credentials.name,
      };

      dispatch(setLoading(false));
      dispatch(
        employeeAuth(
          res.data.token,
          credentials.companyCode,
          credentials.name,
          credentials.businessName
        )
      );
      return Promise.resolve(info);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      return Promise.reject(error);
    });

export const authEmployee = (data) => (dispatch) => {
  dispatch(setLoading(true));
  const url = `/record-reg/companies/${data.cpf}`;

  return timeclockInstance
    .get(url)
    .then((response) => {
      localStorage.setItem(
        "hasBankOfHours",
        response?.data?.companies[0]?.hasBankOfHours
      );
      const credentials = {
        cpf: data.cpf,
        password: data.password,
        companyCode: response.data.companies[0].companyCode,
        name: response.data.employeeName,
        businessName: response.data.companies[0].businessName,
        email: response.data.companies[0].email,
      };

      return verifyCredentials(credentials, dispatch);
    })
    .catch((error) => {
      if (error === "Usuario ou senha incorretos") {
        dispatch(setMessage(error));
      }

      if (error === "O empregado deve cadastrar um usuário antes do login") {
        dispatch(setMessage(error));
      }

      dispatch(setLoading(false));
      return Promise.reject(error);
    });
};

export const resetPassword = (email) => (dispatch) => {
  dispatch(setLoading(true));
  return authInstance
    .post("/authentication/reset/password", email)
    .then(() => {
      dispatch(
        setMessage(
          "Enviamos um email com as instruções para a redefinição de sua senha."
        )
      );
      dispatch(setLoading(false));
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const newPassword = (password, token) => (dispatch) => {
  dispatch(setLoading(true));
  return authInstance
    .post("/authentication/user/set/password", password, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setMessage(response.data.message));
      dispatch(setLoading(false));
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("companyCode");
  localStorage.removeItem("socialName");
  localStorage.removeItem("userName");
  localStorage.removeItem("email");
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("isEmployee");
  localStorage.removeItem("cnpj");
  localStorage.removeItem("hasEmployee");
  localStorage.removeItem("businessName");
  localStorage.removeItem("companies");
  localStorage.removeItem("hasBankOfHours");

  return {
    type: actions.AUTH_LOGOUT,
  };
};

export const checkAuth = () => (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    const companyCode = localStorage.getItem("companyCode");
    const socialName = localStorage.getItem("socialName");
    const userName = localStorage.getItem("userName");
    const isEmployee = localStorage.getItem("isEmployee");
    const cnpj = localStorage.getItem("cnpj");
    const hasEmployee = localStorage.getItem("hasEmployee");
    const businessName = localStorage.getItem("businessName");
    const privilegess = JSON.parse(localStorage.getItem("privileges"));

    dispatch(
      authSuccess(
        token,
        companyCode,
        socialName,
        userName,
        isEmployee,
        cnpj,
        hasEmployee,
        businessName,
        privilegess
      )
    );
  } else {
    dispatch(logout());
  }
};
